<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100 text-center">
          <h1 class="display-3">🔧</h1>
          <h4 class="pt-3">En mantenimiento</h4>
          <p class="text-muted">
            Estamos realizando mejoras en el sistema. Vuelve en unos minutos.
          </p>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Maintenance'
}
</script>
